import React from 'react';
import './pagefooter.css';
import { Helmet } from 'react-helmet-async';

const RefundPolicy = () => (
  <>
    <Helmet>
      <title>Refund Policy | Aikyam Sports Science</title>

      <meta
        name="description"
        content="Read Aikyam Sports Science refund policy for sports science services, products, and bookings."
      />

      <meta
        name="keywords"
        content="Aikyam Sports Science refund policy, sports science services, Udupi sports training"
      />

      <meta property="og:title" content="Refund Policy | Aikyam Sports Science" />
      <meta
        property="og:description"
        content="Details about refunds, approvals, and processing timelines for Aikyam Sports Science."
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://aikyamsports.com/refund-policy"
      />
      <link
        rel="canonical"
        href="https://aikyamsports.com/refund-policy"
      />
    </Helmet>
    <div className="policy-page">
      <h1>Refund Policy</h1>
      <p>We strive to ensure customer satisfaction with our products and services. Please read our refund policy below:</p>
      <ul>
        <li><strong>Service Refunds:</strong> Refunds for services are considered on a case-by-case basis. Please contact us with your concerns.</li>
        <li><strong>Process:</strong> To request a refund, contact us at +916363202281 or +917019386664 with your order details and reason for refund.</li>
        <li><strong>Approval:</strong> Approved refunds will be processed to your original payment method within 7-10 business days.</li>
      </ul>
      <p>Location: Center for Sports Science, Mahatma Gandhi Stadium, Ajjarakad, Brahmagiri, Udupi, Karnataka - 576101</p>
    </div>
  </>
);

export default RefundPolicy;
